module.exports = __webpack_public_path__ + "static/media/cover-button_eng.48a19c40.png";